/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_2_PInputs */

const en_terms_2_p = /** @type {(inputs: Terms_2_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You need a Google account to sign in. Keep your API tokens secret; anything done with your token is treated as done by you. You must be at least 18 years old or have the consent of a legal guardian.`)
};

const id_terms_2_p = /** @type {(inputs: Terms_2_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamu perlu akun Google untuk masuk. Jaga kerahasiaan token API; apa pun yang dilakukan dengan tokenmu dianggap dilakukan olehmu. Kamu harus berusia minimal 18 tahun atau mendapat persetujuan wali.`)
};

/**
* | output |
* | --- |
* | "You need a Google account to sign in. Keep your API tokens secret; anything done with your token is treated as done by you. You must be at least 18 years old..." |
*
* @param {Terms_2_PInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const terms_2_p = /** @type {((inputs?: Terms_2_PInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_2_PInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_terms_2_p(inputs)
	return en_terms_2_p(inputs)
});